module.exports = __webpack_public_path__ + "img/icon_qiye.442d7c63.svg";